export default __webpack_public_path__ + "static/media/Blooded Gauntlets of the Greensward.bebec91d.jpg";